import { useKeycloak } from '@react-keycloak/ssr';
import { KeycloakInstance } from 'keycloak-js';
import { useRouter } from 'next/router';
import { fetchApi } from 'providers/actions/util';
import { ServerSidePropsContext } from 'providers/ServerSideProps';
import { SessionData, SessionDataContext } from 'providers/Session';
import { patchTrialCreditsEarned } from 'providers/Session/actions/patchTrialCreditsEarned';
import { updateSession } from 'providers/Session/actions/updateSession';
import { updateSessionCookie } from 'providers/Session/utils';
import React, { useContext, useEffect, useState } from 'react';
import { Container } from './Restricted.styled';
import RestrictedBanner from './RestrictedBanner.index';
import { Load } from './RestrictedBanner.styled';
import RestrictedGuest from './RestrictedGuest.index';
import { getStoreId } from 'utils/getStoreId';

import RestrictedExpiredPaywall from './RestrictedPaywall/RestrictedExpiredPaywall.index';
import RestrictedGuestPaywall from './RestrictedPaywall/RestrictedGuestPaywall.index';
import RestrictedTrial from './RestrictedPaywall/RestrictedTrialPaywall.index';
import axios from 'axios';
import queryString from 'query-string';

type RestrictedType = {
  articleCid: string;
  trialStage: number;
  setRestrictedArticle: any;
  handleOpenArticle: any;
  author: string;
  publishedDate: string;
  articleType?: string;
};

export type BannerDataType = {
  id: number;
  siteId: string;
  chamadaPrincipal: string;
  chamadaLoja: string;
  condicaoPagamento: string;
  valor: number;
  textoCondicao: string;
  corBackground: string;
  corTexto: string;
  textoLogin: string;
  textoCadastro: string;
  textoAuxiliar: string;
  chavesAcesso: number;
  tipoAcesso: string;
  status: boolean;
};

type handleGetPaywallConfigProps = {
  siteId: string;
  skipCache: boolean;
};

const KEY_USAGE = 'key:usage';

const Restricted: React.FC<RestrictedType> = ({
  articleCid,
  trialStage,
  setRestrictedArticle,
  handleOpenArticle,
  author,
  publishedDate,
  articleType,
}) => {
  const router = useRouter();
  const routerRedirectUrl = window.location.href;
  const serverSideContext = React.useContext(ServerSidePropsContext);
  const { keycloak } = useKeycloak<KeycloakInstance>();
  const isPaywall =
    serverSideContext?.site?.pageConfig?.featureRadioSelectPaywall;
  const [hasAccess, setHasAccess] = useState(true);
  const sessionData = useContext(SessionDataContext);
  const [bannerData, setBannerData] = useState();
  const [lastVisitedURL, setLastVisitedURL] = useState<string | null>(null);
  const siteId = process.env.NEXT_PUBLIC_PAYWALL_PRODUCT || '';

  const handleGetPaywallConfig = async () => {
    const nivelAcesso =
      sessionData?.id && sessionData != null ? 'DEGUSTADOR' : 'VISITANTE';
    const url = `/siteApi/paywallConfig/${siteId}/${nivelAcesso}`;
    const data = await fetchApi(url).then((res) => {
      return res;
    });
    return data;
  };

  useEffect(() => {
    const storedLastURL = sessionStorage.getItem('lastVisitedURL');
    setLastVisitedURL(storedLastURL);

    handleGetPaywallConfig().then((res) => {
      setBannerData(res);
    });
  }, [sessionData]);

  const redirectTo = (path) => {
    window.location.assign(path)
  };

  const unlockContentId = async (cid, sessionData, author, publishedDate) => {
    let chavesUsadas = 0;
    if (sessionData?.inscricaoDegustador?.creditosDegustadorList) {
      sessionData.inscricaoDegustador.creditosDegustadorList.forEach(
        (credito: { quantidade: number }) => {
          chavesUsadas += 3 - credito.quantidade;
        }
      );
    }

    const storeId = getStoreId();

    const email = sessionData?.emailUsuario;
    const customMessage = `Usuário usou ${chavesUsadas + 1} chave(s)`;
    const currentUrl = window.location.href;

    const data = {
      storeId,
      email,
      conversionIdentifier: 'Chave Usada',
      customMessage,
      autorMateria: author,
      dataMateria: publishedDate,
      origemNavegacao: lastVisitedURL,
      editoria: articleType,
      urlNoticia: currentUrl,
    };
  
    const queryStringData = queryString.stringify(data);

    try {
      await axios.post(`/send-keys-to-rdstation?${queryStringData}`,{
        params: { storeId }
      });
      console.log('Dados enviados para o RD Station com sucesso');
    } catch (error) {
      console.error('Erro ao enviar dados para o RD Station', error);
    }

    if (window) {
      window.dispatchEvent(
        new CustomEvent(KEY_USAGE, {
          detail: {
            email: email,
            used: chavesUsadas + 1,
          },
        })
      );
    }

    const patchTrialCreditsEarnedRes = await patchTrialCreditsEarned(
      cid,
      sessionData?.id
    );
    const updatedSession = await updateSession(sessionData?.id).then((res) => {
      if (res.status == 200) {
        return res.data;
      } else {
        return sessionData;
      }
    });

    if (patchTrialCreditsEarnedRes.status != 200) {
      console.log('Erro ao abrir a matéria: ', patchTrialCreditsEarnedRes);
    } else {
      updateSessionCookie(updatedSession);
      handleOpenArticle();
      setRestrictedArticle(false);
    }
  };

  const handleLogin = async () => {
    try {
      await keycloak?.login({
        redirectUri: `${window.location.href}`,
      });
    } catch (error) {
      console.error('Error during login:', error);
    }
  };

  const renderRestrictedView = (stage) => {
    switch (stage) {
      case 1:
        if (isPaywall === 'PIANO') {
          return <RestrictedGuest />;
        } else {
          return (
            <RestrictedGuestPaywall
              bannerData={bannerData}
              handleButton1Click={handleLogin}
              handleButton2Click={() =>
                redirectTo(
                  `${process.env.KEYCLOAK_ISSUER}/protocol/openid-connect/registrations?client_id=${process.env.KEYCLOAK_CLIENT_ID}&response_type=code&scope=openid email&redirect_uri=${routerRedirectUrl}`
                )
              }
              trialSize={
                sessionData?.inscricaoDegustador?.creditosDegustadorList[0]
                  ?.quantidade || 0
              }
            />
          );
        }
      case 2:
        if (isPaywall === 'PIANO') {
          return <RestrictedGuest />;
        } else {
          return (
            <RestrictedTrial
              bannerData={bannerData}
              handleActionClick={() =>
                unlockContentId(articleCid, sessionData, author, publishedDate)
              }
              trialSize={
                sessionData?.inscricaoDegustador?.creditosDegustadorList[0]
                  ?.quantidade || 0
              }
            />
          );
        }

      case 0:
      default:
        return (
          <RestrictedExpiredPaywall
            trialSize={
              sessionData?.inscricaoDegustador?.creditosDegustadorList[0]
                ?.quantidade || 0
            }
            bannerData={bannerData}
          />
        );
    }
  };

  if (isPaywall === 'PIANO') {
    return (
      <>
        <div style={{ display: hasAccess ? 'none' : 'block', width: '100%' }}>
          <Container>{renderRestrictedView(trialStage)}</Container>
        </div>
      </>
    );
  } else {
    return (
      <Container>
        {!bannerData && <Load />}
        {bannerData && renderRestrictedView(trialStage)}
        {bannerData && (
          <RestrictedBanner priceValue="4,90" bannerData={bannerData} />
        )}
      </Container>
    );
  }
};

Restricted.defaultProps = {
  trialStage: 1,
};

export default Restricted;
